<template>
  <div>

    <div class="section-wrap ">
      <div class="c-999 program-label">
        <span @click="routerSkip('/')">{{$t('header.nav1')}}</span>  > <span @click="routerSkip('/about')">{{$t('header.nav2')}} </span>  >
         <span @click="routerSkip('/news')">{{ curData.category ? (curData.category === 2 ? $t('detail.nav3') : $t('detail.nav1')) : ""}} </span>  >   <span class="c-666">{{$t('detail.nav2')}}</span>
      </div>
      <div class=" detail-main  b-fff">
        <div class="detail-header  ">
          <p class="c-333">{{curData.title}}</p>
          <p class="c-999">{{$t('detail.t1')}}：{{curData.releaseTime}}</p>
        </div>
        <div class="detail-content " v-html="curData.article">

          </div>
        <div class="detail-footer clearfix">
          <div @click="routerSkip('/news/detail/'+(curData.prev.id))" v-if="curData.prev">
            <div :style="'background:url('+curData.prev.frontCover+') no-repeat center/cover'"></div>
            <div>
              <p class="c-333">{{$t('detail.t2')}}</p>
            <p class="c-666 cbg-textOver2">{{curData.prev.title}}</p>
            </div>
          </div>
          <div @click="routerSkip('/news/detail/'+(curData.next.id))" v-if="curData.next">
            <div :style="'background:url('+curData.next.frontCover+') no-repeat center/cover'"></div>
            <div>
              <p class="c-333">{{$t('detail.t3')}}</p>
              <p class="c-666 cbg-textOver2">{{curData.next.title}}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { getJournalism } from '@api/index'
  import { mapMutations,mapActions } from 'vuex'


  export default {
    name: 'detail',
    data () {
      return {
          id:0,
          curData:{},
          previd:0,
          nextid:0,
  country:["中国大陆","中国香港","中国台湾","韩国","日本","马来西亚","泰国","新加坡","加拿大","美国","墨西哥","印度尼西亚","越南","德国","英国",],
          list:[{title:'后疫情时代,多因素助力运动鞋服市场腾飞',src: require('@/assets/images/about/news/n1.jpg'),time:'2020年6月12日',content:'<div class="tc"><img class="disInline" src="'+require('@/assets/images/about/news/n1.jpg')+'" /></div><p>政策、健身风、消费升级多方因素利好运动鞋服市场发展:近年来,我国运动健身政策多次鼓励支持引导相关产业发展,运动赛事不断增多,民众参与积极性越来越高,运动健身风起。城镇化的推进,消费升级为运动鞋服行业再添增长动力。</p><p>我国运动鞋服市场体量庞大,行业景气度高:2019年中国运动鞋服市场规模459.5亿美元,同比增长12.6%。然而人均运动鞋服零售额仅为美国的1/12,英国、德国的1/5。</p><p>随着城镇化推进和人均收入的增加,我国人均运动鞋服零售额至少有5倍左右的提升空间。</p><p>行业集中度高,资源不断往头部靠拢:2019年我国运动鞋服行业CR5为72%,较2010年提升21个百分点。市场份额集中在头部企业手中,行业呈现“强者愈强,弱者愈弱”的马太效应。当前,国内品牌在赛事资源和科技等方面,安踏和李宁暂得头筹。</p><p>行业未来发展趋势:国潮、科技、电商并驾齐驱。李宁纽约时装周带火“国潮”之后,其他品牌纷纷效仿。加上科技为运动鞋服赋予的硬核品质,国人对本土品牌好感日渐提升。2018年国人对本土品牌好感度高达80%以上。我国网购接受度高,各大运动鞋服品牌商纷纷布局线上渠道。</p>'},
              {title:'全球供应链深度调整 中国重要性不减反增',src: require('@/assets/images/about/news/n2.jpg'),time:'2020年6月12日',content:'<div class="tc"><img class="disInline" src="'+require('@/assets/images/about/news/n2.jpg')+'" /></div><p>中新社北京6月3日电 (记者 李晓喻)全球贸易正因疫情遭受巨大冲击。不仅贸易总量大幅缩水，产业链供应链布局也面临深度调整。此间学者认为，中国在国际分工格局中的地位不会因疫情削弱，反而会得到强化；与中国“脱钩”无法实现。</p><p>因疫情导致商品、服务和人员自由流动受阻，全球经济与贸易正陷入罕见困境。联合国日前发布报告称，受新冠疫情影响，2020年全球经济预计萎缩3.2%。另据WTO预测，今年全球商品贸易将下降13%～32%，创2008年国际金融危机后新低。</p><p>雪上加霜的是，美国等国为自身产业链供应链安全考虑，开始加紧推动本国企业回流，这进一步加剧了全球产业链供应链面临的困境。</p><p>有分析人士认为，未来全球供应链布局可能出现两种趋势：一方面，某些经济体将更加重视自身供应链的完整性和自主可控性，导致供应链区域化集聚；另一方面，跨国公司为分散风险，会更加重视对供应链实施多元化布局。</p><p>一些供应链的调整已经开始。据外媒报道，从座椅皮革到仪表盘显示芯片的汽车供应链中，已有59%的贸易在区域内进行。</p><p>但部分行业供应链出现调整，并不意味着中国将在全球产业链供应链格局中地位不保。</p><p>目前，中国在国际分工中的重要性已难以被其他国家替代。据麦肯锡全球研究院报告，中国贡献了全球制造业总产出的35%，全球所有行业几乎都在一定程度上依赖中国。</p><p>联合国工业发展组织中国投资促进办事处首席代表武雅斌接受中新社记者采访时称，在此情况下，要想将制造或采购完全转移到中国境外，形成独立于中国的供应链“难度很大”。</p><p>他指出，从中长期来看，一国对全球投资者吸引力的决定性因素有二，一是营商环境，二是该国在全球产业链供应链价值链中所处的地位。中国在这两方面的优势并没有被疫情改变，反而有所强化。“因此，外企有可能在中国以外设立补充生产制造基地以分散风险，但不会鲁莽撤出中国。”</p><p>实际上，近年来不少外企之所以在中国投资，主要是看重中国庞大的市场。用中国商务部原副部长魏建国的话说，对这类企业而言，为了能尽可能快地满足中国消费者的需求，减少成本，实现利益最大化，把生产环节留在中国是最划算的选择。</p><p>把采购转移到中国境外也同样不现实。此前，不少美国企业就表示，很难找到像中国企业这样能够同时满足数量和质量两方面要求的供货商。</p><p>尽管如此，中国仍需尽快采取措施，巩固在全球产业链供应链格局中的地位。</p><p>中国社科院世界经济与政治研究所副研究员马涛称，中国作为亚太地区产业链中的供应链中心，会越来越深刻体会到国际秩序和市场格局变化所带来的冲击和不确定性。</p><p>武雅斌也提醒说，中国眼下当务之急在于“补链”“稳链”“强链”，即加固供应链薄弱环节，稳定产业链，提升在全球价值链中的地位。为实现这一目标，中国可考虑与亚洲主要经济体合作实施产业升级计划，如设立中日韩产业合作基金，鼓励国外新材料、新工艺与中国产能优势相结合等。</p><p>中国已经在采取行动。国务委员兼外交部长王毅在全国两会期间称，中日韩三方要推动复工复产合作，稳定产业链供应链。上周，中国还与东盟发表联合声明，承诺将加强合作，坚定信心。</p><p>中国国际经济交流中心首席研究员张燕生称，中国与日韩、东盟加强合作，有助于区域内产业链供应链畅通，对维护中国产业链供应链安全有利。(完)</p>'},
              {title:'试水“云上广交会”，台州鞋企求突围',src: require('@/assets/images/about/news/n3.jpg'),time:'2020年6月12日',content:'<p>3月以来，他们开始在微信朋友圈打广告，利用线上渠道进行销售。</p><div class="tc"><img class="disInline" src="'+require('@/assets/images/about/news/n3.jpg')+'" /></div><p>在台州，尤其是温岭，鞋业是当地支柱产业之一，不仅在国内市场占据极大的市场份额，还远销俄罗斯、南美、非洲等国家和地区。温岭鞋业产品种类多样，涉及男鞋、女鞋、童鞋等多个种类，是公认的“中国鞋类出口基地”、“中国鞋业名城”。</p><p>但是，受疫情影响，正蓬勃发展的温岭鞋业遭受了巨大的打击，今年以来，国内鞋类市场萎缩，国外市场订单几乎全部取消。借助广交会搬到“云上”的契机，台州大大小小的鞋企开始试水网络直播，坚持研发新产品，寻求摆脱困境的突围之路。</p><p>“云上广交会”做踏板，台州鞋企布局线上销售</p><p>走进台州市欧港鞋业有限公司（以下简称“欧港鞋业”）的样品展厅，映入眼帘的就是被众多样品鞋架环绕的直播区。两个长方形大功率补光灯正明晃晃地照耀着这一专门布置出的直播区域。其中，崭新的LED补光灯、直播手机和麦克风等专业设备也都一一安装到位。</p><p>“这是我们刚布置出来的直播区，这次广交会的直播，我们就准备放在展厅里。”欧港鞋业董事长金永杰介绍，欧港鞋业是典型的外贸企业，出口订单几乎占了全部订单的100%，但今年受疫情影响，来自国外的订单几乎全部取消或延迟，经营一度陷入困境。3月以来，他们开始在微信朋友圈打广告，利用线上渠道进行销售。</p><p>据了解，这次广交会是欧港鞋业第一次尝试以直播的方式进行销售，他们早早地开始了准备。“我们将所有业务员分成一个主播和两个直播助理的组合，连续10天轮班直播。”金永杰说，线上不比线下，不能现场试穿，为了让顾客直观体会到鞋子的上脚效果，他们还安排了模特，在直播中为顾客现场试穿。</p><p>和欧港鞋业一样，这次“云上广交会”是不少传统外贸企业第一次涉足网络直播领域，他们期待着这一全新的销售形式能给他们开辟新的销售渠道。</p><p>温岭市对外贸易有限公司是温岭较早成立的外贸企业，有着30多年从事外贸业务的经验，出口范围遍布全球，也是本次广交会的参展商。对于他们来说，线上展销会也是一个全新的概念。</p><p>“做了几十年外贸，这还是我们第一次网络直播销售。”该公司销售经理叶丹辉告诉记者，疫情暴发以来，国外的老客户大量流失，展销会纷纷取消，外贸企业陷入发展困境。不过，在这样的情况下，他们依然坚持研发新产品，带着夏季新款产品参加广交会。</p><p>谈及参与本次广交会的目标，叶丹辉表示，这次广交会，公司并没有抱太大的期望，只是当做是一次尝试、一个摸索，更多的是想借助这个机会再发现一些新客户，拓展新的销售渠道。“尝试效果好的话，我们后续会考虑一直保留网上直播这一新的销售方式。”</p><p>开设网络培训，代理公司帮小微企业线上接单</p><p>在台州的众多鞋类企业中，小微企业如恒河沙数，数量众多。对于这些小微企业来说，独自负担起一场长达10天的网络直播，并不是一件容易的事。</p><p>浙江中非国际经贸港服务有限公司（以下简称“中非经贸港”），成立于2015年，是一家集金融服务、跨境电子商务、海外业务拓展、总部经济和物流服务于一体的一站式外经贸综合服务平台。成立以来，中非经贸港一直致力于为台州小微企业代理海外业务，已有五年的经验了。这次广交会，中非经贸港也为不少小微企业代理了直播业务，帮助他们减少参展成本。</p><p>“企业直播成本其实不低，一套好的直播设备是最基本的，其中光是一台高清摄像机就价值不菲。”中非经贸港的业务经理金洁说，“一般企业直播会将直播间设置在样品展厅，方便介绍产品，但是很多小微企业甚至没有自己的样品展厅。对他们来说，直播间的装修费用也是一笔不小的支出。”此外，广交会直播还要求全英文、24小时不间断直播，对主播的要求很高，很多小微企业并没有可以承担这一项工作的业务员。</p><p>金洁介绍，在前几届广交会上，中非经贸港代理的鞋类小微企业主要以温岭鞋企为主，今年也不例外。不过相比去年，今年参展的企业少了近三分之一。“今年上半年鞋类外贸生意不好，很多小微企业没有余力研发新产品，决定放弃参展。”金洁告诉记者，“线上广交会毕竟是第一次举办，还有很多企业不太有信心，持观望态度，也没有参加。”</p><p>据了解，近年来，中非经贸港一直在开设直播卖货的培训课，帮助企业转型线上。今年这一课程尤其火爆，不少企业派业务员来学习。“帮企业代理线上参展我们也是第一次，通过这次尝试积累经验后，公司也会考虑开设相应的线上参展培训，为小微企业培养独立线上参展的能力。”金洁说。</p>'},
              {title:'中国国际皮革展引领企业迎战后疫情时代',src: require('@/assets/images/about/news/n4.jpg'),time:'2020年6月12日',content:'<p>“对展商直接给予价格优惠、举办生态皮革成果展、召开发展趋势高峰论坛、开设上下游对接沙龙、举办多场开放式新产品新技术发布会、开展时尚物料流行趋势发布、加大组织国内外专业买家的投入、开办重点展商巡礼系列报道……”这一系列的增值服务、帮扶政策的出台，让今年９月1－3日将在上海如期举办的中国国际皮革展览会再次成为了行业关注的焦点，可谓是亮点频频。同时，此展会也成为了众多行业企业在后疫情时代如何为迎接经济回暖做好准备的期待。</p><div class="tc"><img class="disInline" src="'+require('@/assets/images/about/news/n4.jpg')+'" /></div><p>这次新冠病毒蔓延传播之快、之广，影响之大、之深，也属历史罕见。迅猛肆虐的疫情，对全球经济的负面影响亦是巨大和深远的，皮革这一传统行业也概莫能外。中国皮革协会理事长李玉中分析认为：从消费角度来看，近几个月来，消费者多宅在家中，还有一部分消费者收入减少，对皮革制品的需求明显下降。随着疫情在世界更多国家的蔓延，国际贸易基本推迟或取消，企业的国际订单大幅减少甚至被直接取消。消费需求大幅度降低已成为影响皮革行业健康、持续发展的重要原因之一；再从供给侧角度来看，因消费力不足，导致订单减少，中小微企业的生产经营受到严重影响。再加上部分企业因劳动力不能及时到位、人才流失等多种原因，造成了企业复工而不能复产成了普遍现象。部分已复产企业也因供应链不能正常配套，很难达到基本预期目标。有的企业因资金短缺，不但影响了其购买生产物资及原材料，还将面临倒闭的风险。</p><div class="tc"><img class="disInline" src="'+require('@/assets/images/about/news/n4-2.jpg')+'" /></div><p>随着我国疫情已步入可防可控期，今年下半年起，消费需求将逐渐活跃，专家们预测到明年上半年，有可能会迎来一场报复性消费增长，国内经济也将逐步呈现回暖趋势，企业必将迎来更多的发展新机遇。但随着后疫情时代的来临，中国皮革企业又该如何充分做好经济回暖后的新一轮竞争准备呢？此时的企业正处于迷茫、困惑之中，他们急于在下半年要找到新订单，更需要一个能帮他们提供更多业内企业相互交流的机会。9月份预计如期举办的、被国际权威刊物《world leather》评价为“国际皮革业发展的晴雨表”的中国国际皮革展览会恰逢其时，在此刻必将发挥其重要的引领作用。 </p><p>由中国皮革协会和亚太区皮革展有限公司共同主办的中国国际皮革展览会已有20多年的发展历程，每年都将聚集1000多家国内外企业参展，20000多名专业观众参观洽谈。面对今年的特殊形势，中国皮革协会果断加大对展会的投入力度，在加强与各特色区域政府部门、各地方协商会、各专业市场间的合作外，还加强了对国内外更多专业买家的邀约，并开办了多种形式的帮扶对接活动和增值服务项目，希望能带领企业一起面对这场考验，打赢这场后疫情战役。</p><p>2020年9月1－3日，期待我们能相聚上海，相聚在中国国际皮革展！与君之约，不见不散！</p>'},
              {title:'中国未现产业链供应链外迁',src: require('@/assets/images/about/news/n5.jpg'),time:'2020年6月12日',content:'<div class="tc"><img class="disInline" src="'+require('@/assets/images/about/news/n5.jpg')+'" /></div><p>【大公报讯】记者周琳北京报道：针对外媒近期报道“去中国化”“将供应链搬出中国”的言论，商务部新闻发言人高峰4日在京回应称，中国目前没有出现外资撤离、产业链供应链外迁，相反许多跨国公司正考虑在中国扩张产业链。</p><p>4月服务出口增长3.5%</p><p>高峰指出，国际产业链供应链是在经济全球化过程中企业长期选择形成的，体现了全球各经济体的优势、分工与合作。目前中国没有出现外资撤离、产业链供应链外迁情况。相反，由於中国稳定的营商环境、较强的综合竞争优势、超大规模的市场优势和内需潜力，许多跨国公司正考虑在中国扩张产业链。</p><p>商务部4日发布的数据显示，随着一系列推动企业复工复产和稳外贸、稳外资的政策措施初显成效，4月中国服务出口1612.9亿元人民币，同比增长3.5%，扭转了疫情发生以来单月出口连续下降的局面。</p><p>高峰表示，中国将坚定不移扩大对外开放，继续放宽外资准入限制，扩大鼓励外商投资范围，推动国内产业链供应链提质升级，积极构建国内国际双循环相互促进的新发展格局。</p><p>对於近期美欧因疫情对中国的指责是否会影响国际经贸往来，高峰指出，中方一贯反对将经贸问题政治化。当前，疫情对全球生产和需求造成全面冲击，各国应该加强合作，采取切实行动，推动世界经济尽快复苏。</p>'},
              ]

      }
    },
      watch: {
          $route(val) {
              this.init()
          }
      },
    mounted () {
    this.init()
    },
    methods: {
        init(){

            if(this.$route.params&&this.$route.params.id){
                this.id=this.$route.params.id
                if(this.id==0){
                    this.previd=this.list.length-1
                }else{
                    this.previd=this.id-1
                }
                if(this.id==(this.list.length-1)){
                    this.nextid=0
                }else{
                    this.nextid=this.id-0+1
                }
                // this.curData=this.list[this.id]
                // console.log(this.previd)
                // console.log(this.nextid)
                this.getList()
            }
        },
      getList() {
          getJournalism({id:this.id}).then(res=>{
  if(res.code==0){
      this.curData=res.data
  }else{
      this.$message.error(res.msg)
  }
          })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .realize-more
    user-select none;cursor pointer


   .detail-main{padding:0.25rem 1rem;    padding-bottom: 1.8rem;
    margin-bottom: 1.5rem;
  }
  .detail-header{border-bottom :1px solid #e5e5e5;padding:.24rem 0;
    .c-333{font-size:.28rem;padding-bottom:.1rem;}
    .c-999{font-size:.14rem;}
  }

    .detail-footer{margin-top 0.55rem;
      &>div{width:50%;float :left;padding:.3rem;font-size:.16rem;border:1px solid #e5e5e5;padding-right: 0;cursor pointer;
        &:nth-child(2){border-left:0}
  &>div{display :inline-block;vertical-align middle;}
      &>div:first-child{width:1.22rem;height:.88rem;margin-right .3rem;}
        &>div:nth-child(2){width:2.7rem;
          .c-333{padding-bottom:.1rem;}
        .c-666{line-height:.24rem;}
        }
      }
    }
  @media screen and (max-width: 768px){
    .section-wrap{padding:0;}
    .detail-main{background :#fff;
      padding:0 .24rem;margin-bottom .64rem;
    }
    .detail-header{padding:.3rem 0;background :#fff;
      .c-333{font-size:.4rem;padding-bottom:0.2rem;line-height:.64rem;}
      .c-999{font-size:.24rem;}
    }
    .detail-content{background :#fff;
      p{font-size:.28rem;line-height:.56rem;}
      img{width:100%;}
    }
    .detail-footer{border:1px solid #e5e5e5;padding:0 .24rem;background #fff;
      &>div{width:100%;font-size:.26rem;border:0;border-top:1px solid #e5e5e5;padding-left:0;white-space :nowrap;
        &:first-child{border:0;}
        &>div:first-child{width:2rem;height:1.5rem;margin-right .25rem;}
        &>div:nth-child(2){width:4.19rem;white-space :normal;
          .c-333{padding-bottom:.1rem;}
          .c-666{line-height:.4rem;}
        }
      }
    }

  }
</style>
<style >
  h2,h3,h4,h5,h6,p{
    margin: 0
  }
  body{background :#f8f8f8}
  .detail-content{padding: .2rem 0;text-align:justify;}
  .detail-content  p{font-size:.16rem;color:#666;line-height:2;padding: .15rem 0;}
  .detail-content  img{margin:.2rem auto;max-width: 100%;display: block}
  @media screen and (max-width: 768px){
    .detail-content  p{font-size:.24rem;}
  }
  </style>
